/* Centilmen — Ücretsiz kargo + aksesuar %10 ilerleme çubuğu
   Sepete ekleme pencerelerinde (ürün sayfası ve ana sayfa) gösterilir.
   Sepet sayfasındaki çubuk sections/main-cart-items.liquid içindedir. */
(function () {
  'use strict';
  if (window.__kcYuklendi) return;
  window.__kcYuklendi = true;

  var ESIK = 200000;   // kuruş: 2.000₺
  var UCRET = 13000;   // kuruş: 130₺

  function tl(kurus) {
    return (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '₺';
  }

  function sepet() {
    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cubukHtml(toplam) {
    var yuzde = Math.max(0, Math.min(100, Math.round(toplam / ESIK * 100)));
    var metin, alt;
    if (toplam >= ESIK) {
      metin = '<b>Kargonuz ücretsiz.</b> Aksesuarlarda %10 indirim de sepetinizde geçerli.';
      alt = '';
    } else {
      metin = 'Ücretsiz kargo ve aksesuarlarda %10 indirim için <b>' + tl(ESIK - toplam) + '</b> daha ekleyin.';
      alt = '<small>2.000₺ altındaki siparişlerde kargo ' + tl(UCRET) + '.</small>';
    }
    return '<p class="kc-metin">' + metin + '</p>' +
      '<div class="kc-ray" aria-hidden="true"><span style="width:' + yuzde + '%"></span></div>' + alt;
  }

  function kutuBul(yer, konumla) {
    var kutu = document.querySelector('.kc-kutu[data-kc-yer="' + yer + '"]');
    if (kutu && document.body.contains(kutu)) return kutu;
    kutu = document.createElement('div');
    kutu.className = 'kc-kutu kc-kutu--' + yer;
    kutu.setAttribute('data-kc-yer', yer);
    kutu.setAttribute('role', 'status');
    return konumla(kutu) ? kutu : null;
  }

  function guncelle(yer, konumla) {
    return sepet().then(function (cart) {
      if (!cart || !cart.item_count) return;
      var kutu = kutuBul(yer, konumla);
      if (!kutu) return;
      kutu.innerHTML = cubukHtml(cart.total_price || 0);
    }).catch(function () {});
  }

  // Ürün sayfası: "Sepetinize eklendi" penceresi — ürün listesinin üstüne
  function urunPenceresi() {
    return guncelle('urun', function (kutu) {
      var liste = document.getElementById('lfnModalItemsList');
      if (!liste || !liste.parentNode) return false;
      liste.parentNode.insertBefore(kutu, liste);
      return true;
    });
  }

  // Ana sayfa: sepete ekle açılır penceresi — butonların ve aksesuar önerisinin üstüne
  function anasayfaPenceresi() {
    return guncelle('anasayfa', function (kutu) {
      var aks = document.querySelector('#lfnAtcPopupOverlay .lfn-atc-popup-actions');
      if (!aks || !aks.parentNode) return false;
      var oneri = aks.parentNode.querySelector('.cnaf-kutu');
      aks.parentNode.insertBefore(kutu, oneri || aks);
      return true;
    });
  }

  function sinifIzle(el, sinif, fn) {
    if (!el) return;
    var acik = el.classList.contains(sinif);
    if (acik) fn();
    new MutationObserver(function () {
      var simdi = el.classList.contains(sinif);
      if (simdi && !acik) setTimeout(fn, 60);
      acik = simdi;
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function stilEkle() {
    if (document.getElementById('kcStil')) return;
    var s = document.createElement('style');
    s.id = 'kcStil';
    s.textContent =
      '.kc-kutu{margin:12px 0 14px;padding:12px 14px;border:1px solid #e8e2da;background:#faf8f5;border-radius:6px;text-align:left;font-family:inherit}' +
      '.kc-metin{margin:0 0 9px;font-size:12.5px;line-height:1.45;color:#3a332e;letter-spacing:.01em}' +
      '.kc-metin b{color:#1a1a1a;font-weight:700}' +
      '.kc-ray{height:4px;background:#ece6de;border-radius:4px;overflow:hidden}' +
      '.kc-ray span{display:block;height:100%;background:#1a1a1a;border-radius:4px;transition:width .5s cubic-bezier(.4,0,.2,1)}' +
      '.kc-kutu small{display:block;margin-top:7px;font-size:10.5px;color:#8a7466}';
    document.head.appendChild(s);
  }

  // Pencerede sepet değişirse (ör. aksesuar önerisinden ekleme) çubuğu yenile
  document.addEventListener('cart:refresh', function () {
    setTimeout(function () {
      if (document.querySelector('.kc-kutu--urun')) urunPenceresi();
      if (document.querySelector('.kc-kutu--anasayfa')) anasayfaPenceresi();
    }, 500);
  }, true);

  function baslat() {
    stilEkle();
    sinifIzle(document.getElementById('lfnCartModalBackdrop'), 'is-active', urunPenceresi);
    sinifIzle(document.getElementById('lfnAtcPopupOverlay'), 'active', anasayfaPenceresi);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
